import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  httpClient = inject(HttpClient);
  baseUrl = 'http://localhost:8000/api';

  isSidebarExpanded$ = new BehaviorSubject<boolean>(true);

  constructor() {}

  getSideBarOptions(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/commons/sidebar-options`);
  }

  getNotificationGroupOptions(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/commons/notification-group-options`);
  }
}
